var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-switch',{attrs:{"disabled":!_vm.toggleState},on:{"change":_vm.change},model:{value:(_vm.toggleState),callback:function ($$v) {_vm.toggleState=$$v},expression:"toggleState"}})}
var staticRenderFns = []

export { render, staticRenderFns }